// ----------------------------------------------------------------------
// <copyright file="Izenda.RightPanel.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Right Panel component for Report designer
 */
!(function() {
  var React = require('react');
  var classnames = require('classnames');
  const { isNil } = require('lodash/fp');
  var RightPanel = React.createClass({
    getDefaultProps: function() {
      return {
        initState: true
      };
    },

    getInitialState: function() {
      return {
        isExpanded: this.props.initState
      };
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState({
        isExpanded: nextProps.initState
      });
    },

    toggleRightPanel: function(newState) {
      if (!isNil(newState) && newState === this.state.isExpanded) {
        return;
      }
      this.setState({
        isExpanded: newState !== undefined ? newState : !this.state.isExpanded
      });
    },

    render: function() {
      var sectionClass = classnames({
        'izenda-RightPanel': true,
        expanded: this.state.isExpanded,
        collapsed: !this.state.isExpanded
      });

      return (
        <div className={sectionClass} aria-expanded='false'>
          <div className='u_marginRight u_fullHeight u-bgWhite u-posRelative'>
            {this.renderCollapsibleSection()}

            <section className={'u-bgWhite ' + this.props.className}>{this.props.children}</section>
          </div>
        </div>
      );
    },

    renderCollapsibleSection: function() {
      var iconClass = classnames({
        'collapse-icon': true,
        'icon-right-open': this.state.isExpanded,
        'icon-left-open': !this.state.isExpanded
      });

      return (
        <div className='collapsible'>
          <i className={iconClass} onClick={toggleRightPanel.bind(this)} />

          <span className='u_textBold'>{this.props.title}</span>
        </div>
      );

      function toggleRightPanel() {
        return this.toggleRightPanel();
      }
    }
  });

  module.exports = RightPanel;
})();



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.RightPanel.jsx